document.addEventListener('DOMContentLoaded', function () {
  const gccCountries = ['QA', 'BH', 'KW', 'AE', 'SA'];
  const country = window.Shopify && Shopify.country ? Shopify.country : '';

  const slideshow1 = document.getElementById('shopify-section-template--26795217027253__hero_irjTFL');
  const slideshow2 = document.getElementById('shopify-section-template--26795217027253__hero_YhPaQd');

  if (gccCountries.includes(country)) {
    // GCC → show second, hide first
    if (slideshow1) slideshow1.style.display = 'none';
    if (slideshow2) slideshow2.style.display = 'block';
  } else {
    // Rest of world → show first, hide second
    if (slideshow1) slideshow1.style.display = 'block';
    if (slideshow2) slideshow2.style.display = 'none';
  }
});
